export class FacilityCalendarDay {
  day: string;
  events: number;
  userEvents: number;
  hasPendingConfirmation: boolean;
  hasWaitingApproval: boolean;
  hasWaitingQueue: boolean;
}
